'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


var FechaLargaFilter = function FechaLargaFilter(filter, fechaConfig, moment) {

    return function (input) {

        if (input == null) {
            return '';
        }

        return filter('date')(moment(input).format('LL'));
    };
};

FechaLargaFilter.$inject = ['$filter', 'fechaConfig', 'moment'];

exports.default = FechaLargaFilter;


// WEBPACK FOOTER //
// ./src/busqueda/filtros/fechalarga.filter.js